export const buildTerminalUrl = (
  terminal: string,
  tokenAddress: string,
  pairAddress: string
): string => {
  switch (terminal) {
    case 'axiom':
      return `https://axiom.trade/meme/${pairAddress}?chain=sol`;
    case 'padre':
      return `https://trade.padre.gg/trade/solana/${pairAddress}`;
    case 'gmgn':
      return `https://gmgn.ai/sol/token/${tokenAddress}`;
    case 'bullx':
      return `https://neo.bullx.io/terminal?chainId=1399811149&address=${tokenAddress}`;
    case 'photon':
      return `https://photon-sol.tinyastro.io/en/lp/${pairAddress}`;
    case 'trojan':
      return `https://trojan.com/terminal?token=${tokenAddress}&pool=${pairAddress}`;
    default:
      return `https://axiom.trade/meme/${pairAddress}?chain=sol`;
  }
};
